export interface EmailCategory {
    id: string;
    email: string;
    order: number;
}

export const SENDER_EMAIL_CATEGORY_ENUM: Record<string, EmailCategory> = {
    REPORT_FORM: {
        id: 'report-form',
        email: 'report-form@place2play.net',
        order: 1
    },
}

export const REPORT_CATEGORY_EMAILS_ENUM: Record<string, EmailCategory> = {
    ENHANCEMENT: {
        id: 'enhancement',
        email: 'enhancement@place2play.net',
        order: 1
    },
    BUG:{
        id: 'bug',
        email: 'bug@place2play.net',
        order: 2
    },
    LEGAL: {
        id: 'legal',
        email: 'legal@place2play.net',
        order: 3
    },
    SUPPORT: {
        id: 'support',
        email: 'support@place2play.net',
        order: 4
    }
}